/**
 * Created by ddodson on 12/15/15.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import styles from './BarChart.css';
import withStyles from '../../decorators/withStyles';
import { shrinkWrapYAxis, xlt } from "../../utils/utils";

const d3 = require('d3');
d3.tip = require('d3-tip').default;


class BarChart extends Component {

  static propTypes = {
    data: PropTypes.array.isRequired,
    isWaterLevel: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.create(
      ReactDOM.findDOMNode(this),
      typeof this.props.data !== 'undefined' ? this.props.data : []
    );
  }

  componentDidUpdate() {
    this.update(
      ReactDOM.findDOMNode(this),
      typeof this.props.data !== 'undefined' ? this.props.data : []
    );
  };

  componentWillUnmount() {
    var el = ReactDOM.findDOMNode(this);
    this.destroy(el);
  }

  create(element, data) {
    const { width, height, margin } = this.props;

    var svgWidth = width + margin.left + margin.right;
    var svgHeight = height + margin.top + margin.bottom;

    this.tip = d3.tip().attr("class", "d3-tip")
      .direction("n")
      .offset([-5, 0])
      .html((d) => d.text);
      // .html((d) => this.props.isWaterLevel ? d.y : `${(d.y * 100).toFixed(1)}%`);

    var svg = d3.select(element).append("svg")
      .attr("viewBox", "0 0 " + svgWidth + " " + svgHeight)
      .attr("id", this.props.id)
      .append("g")
      .classed("graph-canvas", true)
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg.call(this.tip);

    this.update(element, data);
  };

  update(element, data) {
    const { width, height, isWaterLevel, margin, xLabel, yLabel, yMax } = this.props;
    var self = this;

    var x = d3.scaleBand()
      .rangeRound([0, width]).padding(0.1);

    var y = d3.scaleLinear()
      .range([height, 0]);

    x.domain(data.map((d) => d.x));
    const max = yMax > d3.max(data, (d) => d.y) ? yMax : d3.max(data, (d) => d.y);
    y.domain(isWaterLevel ? [0, max] : [0, max]);

    var yTickFormat = isWaterLevel ? ',.0f' : '%';

    var svg = d3.select(element).selectAll(".graph-canvas");

    var xAxis = d3.axisBottom(x)
      .tickValues(data.length > 10 ? x.domain().filter((_, i) => !(i % 2)) : x.domain());

    var yAxis = d3.axisLeft(y)
      .ticks(5, yTickFormat);

    svg.selectAll(".x.axis").remove();
    svg.selectAll(".y.axis").remove();

    svg.append("g")
      .classed("x axis", true)
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)
      .append("text")
      .attr("y", margin.bottom / 2)
      .attr("x", width / 2)
      .attr("dy", "1.5em")
      .style("text-anchor", "middle")
      .text(xlt(xLabel));

    svg.append("g")
      .classed("y axis", true)
      .call(yAxis)
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", - margin.left)
      .attr("x", - (height / 2))
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text(xlt(yLabel));
      
    // shrink and wrap y-axis text to 2 lines if it's too long
    svg.selectAll(".y.axis > text").each(function(d) {
      shrinkWrapYAxis(this, 2, height);
    });

    var bar = svg.selectAll(".bar")
      .data(data);

    bar
      .on("mouseover", this.tip.show)
      .on("mouseout", this.tip.hide)
      .transition()
      .attr("class", (d) => "bar")
      .duration(300)
      .attr("x", (d) => x(d.x))
      .attr("width", x.bandwidth() - 5)
      .attr("y", (d) => y(d.y))
      .attr("height", (d) => (height - y(d.y)));

    bar.enter().append("rect")
      .on("mouseover", this.tip.show)
      .on("mouseout", this.tip.hide)
      .attr("class", (d) => "bar")
      .attr("x", (d) => x(d.x))
      .attr("width", x.bandwidth() - 5)
      .attr("y", (d) => y(d.y))
      .attr("height", (d) => (height - y(d.y)));

    bar.exit().remove();
  };

  destroy(element) {
    // TODO
  };

  render() {
    return <div className="BarChart">{this.props.children}</div>;
  }

}

export default withStyles(styles)(BarChart);
